import { init, Models, RematchDispatch, RematchRootState } from '@rematch/core';
import immerPlugin from '@rematch/immer';
import { Middleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { EnvironmentService } from '@/services/Environment';

import { leadCreationModel } from './reducers/leads/model';
import { reportModel } from './reducers/reports/model';
import { reducers } from './reducers';
import { rootSaga } from './sagas';

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

// Gather all middlewares
const allMiddlewares: Middleware[] = [sagaMiddleware];

// Add logger on DEV environment
if (EnvironmentService.withLogs) {
  allMiddlewares.push(data => next => action => {
    const result = next(action);

    console.groupCollapsed(action.type);
    console.log(data.getState());
    console.groupEnd();

    return result;
  });
}

export interface RootModel extends Models<RootModel> {
  reports: typeof reportModel;
  leads: typeof leadCreationModel;
}

const models: RootModel = {
  reports: reportModel,
  leads: leadCreationModel,
};

// adding root prefix to avoid name clashes with the other types
export type RootDispatch = RematchDispatch<RootModel>;
export type RootState = RematchRootState<RootModel>;

// Create Redux store
export const store = init({
  redux: {
    reducers: reducers,
    middlewares: allMiddlewares,
  },
  models,
  plugins: [immerPlugin<RootModel>()],
});

// Apply all Sagas
sagaMiddleware.run(rootSaga);
